import type React from 'react'
import type { JSX } from 'react'
import type { DescriptionRowGap } from 'blocks/Description'
import type {
  TextBlockAlignItems,
  TextBlockJustifyContent,
} from './TextBlock.h'

import { TextBlockDirection, TextBlockRowGap } from './TextBlock.h'
import { Wrapper } from './TextBlock.styled'

export interface ITextBlockProps {
  children?: React.ReactNode
  direction?: TextBlockDirection
  rowGap?: TextBlockRowGap | DescriptionRowGap
  alignItems?: TextBlockAlignItems
  justifyContent?: TextBlockJustifyContent
  flexBasis?: number
  flexGrow?: number
  width?: number
  flexBasisAuto?: boolean
}

export const TextBlock: React.FunctionComponent<ITextBlockProps> = ({
  children,
  direction = TextBlockDirection.COLUMN,
  rowGap = TextBlockRowGap.INDENT_10,
  alignItems,
  justifyContent,
  flexBasis,
  flexGrow,
  width,
  flexBasisAuto,
}): JSX.Element => (
  <Wrapper
    flexBasisAuto={flexBasisAuto}
    direction={direction}
    rowGap={rowGap}
    alignItems={alignItems}
    justifyContent={justifyContent}
    flexBasis={flexBasis}
    flexGrow={flexGrow}
    width={width}
  >
    {children}
  </Wrapper>
)
